import React from "react";

const EMPTY_ADV = {
  from: "",
  to: "",
  area: "",
  minRisk: "",
  maxRisk: "",
  status: [],
  severity: [],
  overdueOnly: false,
  assignees: [],
};

export default function UAUCAdvancedFilters({ adv, setAdv, assignees }) {
  const filtersActive =
    adv.from ||
    adv.to ||
    adv.area ||
    adv.minRisk ||
    adv.maxRisk ||
    adv.status.length ||
    adv.severity.length ||
    adv.overdueOnly ||
    adv.assignees.length;

  return (
    <div className="grid grid-cols-1 gap-3 border-b border-slate-200 bg-slate-50 p-4 sm:grid-cols-2 lg:grid-cols-4">
      <label className="text-xs font-bold text-slate-600">
        From
        <input
          type="datetime-local"
          className="mt-1 h-10 w-full rounded-xl border border-slate-300 px-3 text-sm"
          value={adv.from}
          onChange={(e) => setAdv((s) => ({ ...s, from: e.target.value }))}
        />
      </label>

      <label className="text-xs font-bold text-slate-600">
        To
        <input
          type="datetime-local"
          className="mt-1 h-10 w-full rounded-xl border border-slate-300 px-3 text-sm"
          value={adv.to}
          onChange={(e) => setAdv((s) => ({ ...s, to: e.target.value }))}
        />
      </label>

      <label className="text-xs font-bold text-slate-600">
        Area
        <input
          type="text"
          className="mt-1 h-10 w-full rounded-xl border border-slate-300 px-3 text-sm"
          value={adv.area}
          onChange={(e) => setAdv((s) => ({ ...s, area: e.target.value }))}
        />
      </label>

      <div className="flex gap-2">
        <label className="flex-1 text-xs font-bold text-slate-600">
          Min Risk
          <input
            type="number"
            className="mt-1 h-10 w-full rounded-xl border border-slate-300 px-3 text-sm"
            value={adv.minRisk}
            onChange={(e) => setAdv((s) => ({ ...s, minRisk: e.target.value }))}
          />
        </label>

        <label className="flex-1 text-xs font-bold text-slate-600">
          Max Risk
          <input
            type="number"
            className="mt-1 h-10 w-full rounded-xl border border-slate-300 px-3 text-sm"
            value={adv.maxRisk}
            onChange={(e) => setAdv((s) => ({ ...s, maxRisk: e.target.value }))}
          />
        </label>
      </div>

      <label className="text-xs font-bold text-slate-600">
        Severity
        <select
          multiple
          className="mt-1 h-24 w-full rounded-xl border border-slate-300 px-3 text-sm"
          value={adv.severity}
          onChange={(e) =>
            setAdv((s) => ({
              ...s,
              severity: Array.from(e.target.selectedOptions, (o) => o.value),
            }))
          }
        >
          <option value="Low">Low</option>
          <option value="Moderate">Moderate</option>
          <option value="High">High</option>
          <option value="Critical">Critical</option>
        </select>
      </label>

      <label className="text-xs font-bold text-slate-600">
        Assignees
        <select
          multiple
          className="mt-1 h-24 w-full rounded-xl border border-slate-300 px-3 text-sm"
          value={adv.assignees}
          onChange={(e) =>
            setAdv((s) => ({
              ...s,
              assignees: Array.from(e.target.selectedOptions, (o) => o.value),
            }))
          }
        >
          {assignees.map((a) => (
            <option key={a.id} value={a.id}>
              {a.name}
            </option>
          ))}
        </select>
      </label>

      <label className="flex items-center gap-2 text-sm font-bold text-slate-700">
        <input
          type="checkbox"
          checked={adv.overdueOnly}
          onChange={(e) =>
            setAdv((s) => ({ ...s, overdueOnly: e.target.checked }))
          }
        />
        Overdue Only
      </label>

      <div className="col-span-full flex items-center gap-2">
        <button
          type="button"
          className="rounded-xl border border-slate-300 bg-white px-3 py-2 text-xs font-black text-slate-700"
          onClick={() => setAdv(EMPTY_ADV)}
        >
          Clear filters
        </button>
        {filtersActive && (
          <span className="text-xs font-bold text-slate-500">
            Filters active
          </span>
        )}
      </div>
    </div>
  );
}
